(function () {
  'use strict';
  var CACHE = {};
  var CLS = 'sa-cap-price';
  var STYLE_ID = 'sa-cap-price-style-v2';
  var DELAY = 1000; // 1 second delay

  function init() {
    // Clean up anything left by the old version
    var old = document.getElementById('sa-compare-at-price-style');
    if (old) old.remove();

    if (!document.getElementById(STYLE_ID)) {
      var s = document.createElement('style');
      s.id = STYLE_ID;
      s.textContent =
        '.swatches .swatch-price-adjacent{display:flex!important;flex-direction:row!important;flex-wrap:wrap!important;align-items:center!important;justify-content:center!important;gap:6px!important;}' +
        '.swatches .swatch-price-adjacent > span:not(.' + CLS + '){color:#e00000!important;}' +
        '.swatches .swatch-price-adjacent > span.' + CLS + '{color:#000000!important;opacity:1!important;width:auto!important;font-size:0.85em;text-decoration:line-through;line-height:1.2;}';
      document.head.appendChild(s);
    }

    function getProduct(url) {
      var handle = url.split('?')[0].replace(/\/$/, '');
      if (!CACHE[handle]) {
        CACHE[handle] = fetch(handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return CACHE[handle];
    }

    // Format cents like the displayed price (e.g. "€29,90")
    function formatLike(sampleText, cents) {
      var amount = (cents / 100).toFixed(2);
      var m = sampleText.match(/\d[\d.,\s\u00a0]*/);
      if (!m) return amount;
      var num = m[0].trim();
      var lastSep = num.match(/[.,](?=\d{1,2}$)/);
      var dec = lastSep ? lastSep[0] : '.';
      var thou = dec === ',' ? '.' : ',';
      var parts = amount.split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return sampleText.replace(num, lastSep ? intPart + dec + parts[1] : intPart);
    }

    function process(item) {
      var priceEl = item.querySelector('.swatch-price-adjacent');
      if (!priceEl || priceEl.querySelector('.' + CLS)) return;
      var priceSpan = priceEl.querySelector('span') || priceEl;
      var priceText = priceSpan.textContent.trim();
      if (!priceText) return;

      var selector = item.querySelector('[swatch-url]');
      var url = selector && selector.getAttribute('swatch-url');
      if (!url) return;

      getProduct(url).then(function (p) {
        if (!p || priceEl.querySelector('.' + CLS)) return;
        var shownCents = Math.round(parseFloat(
          priceText.replace(/[^\d.,]/g, '').replace(/[.,](?=\d{3}\b)/g, '').replace(',', '.')
        ) * 100);
        var v = (p.variants || []).filter(function (x) {
          return x.price === shownCents && x.compare_at_price;
        })[0];
        var cap = v ? v.compare_at_price : p.compare_at_price;
        var price = v ? v.price : p.price;
        if (!cap || cap <= price) return;

        var el = document.createElement('span');
        el.className = CLS;
        el.setAttribute('swatch-inside', 'true');
        el.textContent = formatLike(priceText, cap);
        priceEl.appendChild(el);
      });
    }

    function run() {
      document.querySelectorAll('.swatch-view-item').forEach(process);
    }

    run();
    // Swatch King re-renders swatches, so watch the page for changes
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  setTimeout(init, DELAY);
})();